/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type DropdownCategories_allCategories$ref = any;
type IngredientRecipeModal_allIngredients$ref = any;
type IngredientRecipeModal_allUnitMeasure$ref = any;
type StepRecipeModal_allWarnings$ref = any;
type StepRecipeModal_configConstance$ref = any;
export type queries_GeneralInfoQueryVariables = {||};
export type queries_GeneralInfoQueryResponse = {|
  +faqsContent: ?{|
    +content: ?string
  |},
  +privacyContent: ?{|
    +content: ?string
  |},
  +allCategories: ?{|
    +$fragmentRefs: DropdownCategories_allCategories$ref
  |},
  +allWarnings: ?{|
    +$fragmentRefs: StepRecipeModal_allWarnings$ref
  |},
  +configConstance: ?{|
    +$fragmentRefs: StepRecipeModal_configConstance$ref
  |},
  +allIngredients: ?{|
    +$fragmentRefs: IngredientRecipeModal_allIngredients$ref
  |},
  +allUnitMeasure: ?{|
    +$fragmentRefs: IngredientRecipeModal_allUnitMeasure$ref
  |},
|};
export type queries_GeneralInfoQuery = {|
  variables: queries_GeneralInfoQueryVariables,
  response: queries_GeneralInfoQueryResponse,
|};
*/


/*
query queries_GeneralInfoQuery {
  faqsContent {
    content
  }
  privacyContent {
    content
  }
  allCategories {
    ...DropdownCategories_allCategories
  }
  allWarnings {
    ...StepRecipeModal_allWarnings
  }
  configConstance {
    ...StepRecipeModal_configConstance
  }
  allIngredients {
    ...IngredientRecipeModal_allIngredients
  }
  allUnitMeasure {
    ...IngredientRecipeModal_allUnitMeasure
  }
}

fragment DropdownCategories_allCategories on RecipeCategoryNodeConnection {
  edges {
    node {
      id
      name
      picture
    }
  }
}

fragment IngredientRecipeModal_allIngredients on IngredientNodeConnection {
  edges {
    node {
      id
      name
    }
  }
}

fragment IngredientRecipeModal_allUnitMeasure on UnitMeasureNodeConnection {
  edges {
    node {
      description
      code
      id
    }
  }
}

fragment StepRecipeModal_allWarnings on WarningNodeConnection {
  edges {
    node {
      id
      slugName
    }
  }
}

fragment StepRecipeModal_configConstance on ConfigConstance {
  speedLimit
  temperatureControlLimit
  temperatureDegreesMin
  temperatureDegreesMax
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "content",
    "storageKey": null
  }
],
v1 = {
  "alias": null,
  "args": null,
  "concreteType": "StaticContent",
  "kind": "LinkedField",
  "name": "faqsContent",
  "plural": false,
  "selections": (v0/*: any*/),
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "StaticContent",
  "kind": "LinkedField",
  "name": "privacyContent",
  "plural": false,
  "selections": (v0/*: any*/),
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "queries_GeneralInfoQuery",
    "selections": [
      (v1/*: any*/),
      (v2/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "RecipeCategoryNodeConnection",
        "kind": "LinkedField",
        "name": "allCategories",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "DropdownCategories_allCategories"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "WarningNodeConnection",
        "kind": "LinkedField",
        "name": "allWarnings",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "StepRecipeModal_allWarnings"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ConfigConstance",
        "kind": "LinkedField",
        "name": "configConstance",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "StepRecipeModal_configConstance"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "IngredientNodeConnection",
        "kind": "LinkedField",
        "name": "allIngredients",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "IngredientRecipeModal_allIngredients"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "UnitMeasureNodeConnection",
        "kind": "LinkedField",
        "name": "allUnitMeasure",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "IngredientRecipeModal_allUnitMeasure"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "queries_GeneralInfoQuery",
    "selections": [
      (v1/*: any*/),
      (v2/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "RecipeCategoryNodeConnection",
        "kind": "LinkedField",
        "name": "allCategories",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "RecipeCategoryNodeEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "RecipeCategoryNode",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "picture",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "WarningNodeConnection",
        "kind": "LinkedField",
        "name": "allWarnings",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "WarningNodeEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "WarningNode",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "slugName",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ConfigConstance",
        "kind": "LinkedField",
        "name": "configConstance",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "speedLimit",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "temperatureControlLimit",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "temperatureDegreesMin",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "temperatureDegreesMax",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "IngredientNodeConnection",
        "kind": "LinkedField",
        "name": "allIngredients",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "IngredientNodeEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "IngredientNode",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "UnitMeasureNodeConnection",
        "kind": "LinkedField",
        "name": "allUnitMeasure",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UnitMeasureNodeEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "UnitMeasureNode",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "description",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "code",
                    "storageKey": null
                  },
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "queries_GeneralInfoQuery",
    "operationKind": "query",
    "text": "query queries_GeneralInfoQuery {\n  faqsContent {\n    content\n  }\n  privacyContent {\n    content\n  }\n  allCategories {\n    ...DropdownCategories_allCategories\n  }\n  allWarnings {\n    ...StepRecipeModal_allWarnings\n  }\n  configConstance {\n    ...StepRecipeModal_configConstance\n  }\n  allIngredients {\n    ...IngredientRecipeModal_allIngredients\n  }\n  allUnitMeasure {\n    ...IngredientRecipeModal_allUnitMeasure\n  }\n}\n\nfragment DropdownCategories_allCategories on RecipeCategoryNodeConnection {\n  edges {\n    node {\n      id\n      name\n      picture\n    }\n  }\n}\n\nfragment IngredientRecipeModal_allIngredients on IngredientNodeConnection {\n  edges {\n    node {\n      id\n      name\n    }\n  }\n}\n\nfragment IngredientRecipeModal_allUnitMeasure on UnitMeasureNodeConnection {\n  edges {\n    node {\n      description\n      code\n      id\n    }\n  }\n}\n\nfragment StepRecipeModal_allWarnings on WarningNodeConnection {\n  edges {\n    node {\n      id\n      slugName\n    }\n  }\n}\n\nfragment StepRecipeModal_configConstance on ConfigConstance {\n  speedLimit\n  temperatureControlLimit\n  temperatureDegreesMin\n  temperatureDegreesMax\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '4457fd94b4a242a5e0c27d60a6afe3d5';

module.exports = node;
